import { get, getOrThrow } from './common';

export interface AddressResource {
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  buildingNumber?: string;
  county?: string;
  label?: any;
  postcode: string;
  street?: string;
  summary?: string;
  town: string;
}

export interface Addresses {
  addresses: AddressResource[];
}

export interface OnfidoAddress {
  town: string;
  addressLine1: string;
  addressLine2?: string;
  buildingName?: string;
  postCode: string;
  buildingNumber: string;
  flatNumber?: string;
  street?: string;
  subStreet?: string;
  summary: string;
}

export interface OnfidoAddresses {
  addresses: OnfidoAddress[];
}

export default function getAddresses(postCode: string) {
  return get<OnfidoAddresses>(`addresses?postCode=${postCode}`);
}

export async function getSimpleAddresses(postCode: string) {
  return getOrThrow<Addresses>(`addresses/simple?postCode=${postCode}`);
}



// WEBPACK FOOTER //
// ./src/helpers/api/addresses.ts